export const MAX_APP_NAME_LENGTH = 30;

export const MAX_SHORT_DESCRIPTION_LENGTH = 80;

export const MAX_LONG_DESCRIPTOIN_LENGTH = 3596;

export const FORM_API = "business/credits/creator/app/settings/post";

export const APP_FORM_KEYS = {
  APP_NAME: "app_name",
  SHORT_DESCRIPTION: "short_description",
  FULL_DESCRIPTION: "long_description",
  APP_ICON: "app_icon",
  APP_BANNER: "feature_graphic",
  PROMO_VIDEO: "promo_video_link",
  APP_HOME_SCREEN_IMAGES: "home_screen_slider_images",
  PLAYSTORE_DISPLAY_IMAGES: "playstore_app_display_images",
  APP_SUPPPORT_EMAIL: "support_email",
  APP_SUPPORT_PHONE: "support_phone",
  APP_SUPPORT_PHONE_COUNTRY: "support_phone_country_code",
  APP_PRIMARY_COLOR: "primary_color",
  APP_SECONDARY_COLOR: "secondary_color",
  APP_BG_COLOR: "page_background_color",
  APP_BUTTON_TEXT_COLOR: "button_text_color",
  APP_CUSTOMS_SIDE_NAV_LINKS: "custom_links_side_nav",
  APP_STORE_LINK: "android_app_link",
  PLAYSTORE_LINK: "ios_app_link",
};

export const APP_IMAGE_KEYS = {
  HOME_SCREEN_IMAGES: [
    "home_screen_images_1",
    "home_screen_images_2",
    "home_screen_images_3",
    "home_screen_images_4",
  ],
  PLAYSTORE_APP_IMAGES: [
    "play_store_images_1",
    "play_store_images_2",
    "play_store_images_3",
    "play_store_images_4",
  ],
};
